import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=18803a28&scoped=true"
import script from "./rule.vue?vue&type=script&lang=ts"
export * from "./rule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18803a28",
  null
  
)

export default component.exports